import { useMutation } from "react-query";
import { useIvideon } from "./useIvideon";
import { AcceptActIProps } from "../model/schema";

export default function useAcceptAct() {
  const { acceptAct } = useIvideon();
  const mutation = useMutation({
    mutationFn: (data: AcceptActIProps) => acceptAct(data),
  });
  return { ...mutation, acceptAct: mutation.mutateAsync };
}
